var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('desktop-manager-component',{attrs:{"desktopManagerOnly":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }